import { useState } from "react";

export default function useToggle(){
    const [ toggle, setToggle ] = useState(false);

    const toggleOn = () => setToggle(true);
    const toggleOff = () => setToggle(false);

    return [ toggle, toggleOn, toggleOff ];
}